import React from 'react'
import PropTypes from 'prop-types'

// Import themes modules
import COLORS from '../../themes/Colors'
import { px2Rem } from '../../themes/Mixins'

// Import common components
import Description from './Description'
import { FlexBox } from './Box'
import Icon from './Icon'

// Defined component Icon
const CircleIcon = ({ icon, size, text, customStyle, children }) => {
  return (
    <FlexBox
      width={size}
      height={size}
      borderRadius='50%'
      bgColor={COLORS.baseBlue}
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      customStyle={customStyle}
    >
      {
        icon &&
        <Icon
          icon={icon}
          customStyle={{ marginBottom: `${px2Rem(10)}` }}
        />
      }
      {children}
      <Description
        text={text}
        color={COLORS.white}
        type={'tiny'}
        customStyle={{ marginBottom: '0' }}
      />
    </FlexBox>
  )
}

// Defined Prop Types
CircleIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.string,
  text: PropTypes.string
}

// Defined default Props
CircleIcon.defaultProps = {
  icon: '',
  size: `${px2Rem(150)}`,
  text: ''
}

export default CircleIcon



// WEBPACK FOOTER //
// ./src/components/common/CircleIcon.js